module.exports = __webpack_public_path__ + "static/media/hardware.60b3cf48.jpg";